import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col, Spinner, Table } from "react-bootstrap";
import {
  triggerZohoLeaveSync,
  getZohoSyncAudit,
  getLatestZohoSyncDate,
} from "../../services/util";

const ZohoAudit = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    initializeDates();
    loadAuditData();
  }, []);

  const loadAuditData = async () => {
    setLoading(true);
    try {
      const res = await getZohoSyncAudit();
      setAuditData(res.data);
    } catch (err) {
      alert("Failed to load audit data");
    }
    setLoading(false);
  };

  const initializeDates = async () => {
    try {
      const res = await getLatestZohoSyncDate();

      //  If we have previous sync data
      if (res?.data && res.data.length > 0 && res.data[0].CreatedDate) {
        setFromDate(res.data[0].CreatedDate); // YYYY-MM-DD
      }
    } catch (err) {
      console.warn("Could not fetch last sync date");
    }

    //  Always set To Date as today
    const today = new Date().toISOString().split("T")[0];
    setToDate(today);
  };


  const handleSync = async () => {
    if (!fromDate || !toDate) {
      alert("Please select From and To dates");
      return;
    }

    setSyncing(true);
    try {
      await triggerZohoLeaveSync(fromDate, toDate);
      await loadAuditData(); //  Refresh table after sync
    } catch (err) {
      alert("Zoho Sync Failed");
    }
    setSyncing(false);
  };

  return (
    <div className="container-fluid">
      {/*  Top 20% */}
      <div className="p-3 border mb-3">
        <Row>        
            <Col md={4}>
              <div className="d-flex align-items-center">
                <Form.Label className="mb-0 me-2" style={{ minWidth: "80px" }}>
                  From Date
                </Form.Label>
                <Form.Control
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
            </Col>

            <Col md={4}>
              <div className="d-flex align-items-center">
                <Form.Label className="mb-0 me-2" style={{ minWidth: "80px" }}>
                  To Date
                </Form.Label>
                <Form.Control
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
            </Col>          
            <Col md={4} className="d-flex align-items-center">
              <Button onClick={handleSync} disabled={syncing}>
                {syncing ? (
                  <Spinner size="sm" animation="border" />
                ) : (
                  "Trigger Sync"
                )}
              </Button>
            </Col>
        </Row>
      </div>

      {/*  Bottom 80% */}
      <div>
        {loading ? (
          <Spinner animation="border" />
        ) : (
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>From Date</th>
                <th>To Date</th>
                {/* <th>Total Records Fetched</th>
                <th>Inserted Rows</th>
                <th>Skipped Duplicates</th>
                <th>Skipped Missing Emp</th> */}
                <th>Status</th>
                <th>Synced On</th>
              </tr>
            </thead>
            <tbody>
              {auditData.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No audit data
                  </td>
                </tr>
              ) : (
                auditData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.fromDate?.split("T")[0]}</td>
                    <td>{row.toDate?.split("T")[0]}</td>
                    {/* <td>{row.totalRecords}</td>
                    <td>{row.insertedCount}</td>
                    <td>{row.skippedDuplicates}</td>
                    <td>{row.skippedMissingEmp}</td> */}
                    <td>
                      <span
                        className={
                          row.status === "SUCCESS"
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {row.status}
                      </span>
                    </td>
                    <td>{new Date(row.createdOn).toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default ZohoAudit;
